import React from 'react';
import styled from 'styled-components';

const Title = styled.div`
  padding: 25px 0;
  align-self: center;
  text-align: ${({ align }) => align || 'center'};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display:inline-block;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

const TitleText = styled.h1`
  font-size: 18px !important;
  font-weight: normal !important;
  text-overflow: ellipsis;
  overflow: hidden;
  color: white;
`;

const HeaderTitle = ({ title, align }) => (
  <Title align={align}>
    <TitleText>
      {title}
    </TitleText>
  </Title>
);

export default HeaderTitle;
